






















import _ from "lodash";
import {Component, Mixins} from "vue-property-decorator";
import {Route} from "vue-router";

@Component
export default class ReportDetailView extends Mixins() {
	public stepper: number = 1;
	public steppers: any[] = [
		{
			id: 1,
			name: "Constituent Entities",
			route: "constituent.entity"
		},
		{id: 2, name: "Reporting Entity", route: "reporting.entity"},
		{
			id: 3,
			name: "Additional Information",
			route: "additional.information"
		},
		{id: 4, name: "Reports", route: "report.body"}
	];

	public created() {
		this.setStepper(this.$route.name);
		this.$router.afterEach((to: Route, from: Route) => this.setStepper(to.name));
	}

	private setStepper(name: string | null | undefined) {
		if (name) {
			const step = _.find(this.steppers, x => name.search(x.route) === 0);
			if (step) this.stepper = step.id;
		}
	}
}
